<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <span
              v-on="on"
              class="d-flex flex-1 align-center sub-header1 bold text-tcdc-grey1 color-grey1"
      >
        {{localeChange(showDate)}}
      </span>
    </template>
    <v-date-picker
      color="#2e8037"
      v-model="date"
      :show-current="false"
      type="month"
      @change="onChange"
      :locale="lang"
      @input="menu = false"
    ></v-date-picker>
  </v-menu>
</template>

<script>
  import { mapState } from 'vuex';
  import moment from "moment";
export default {
  props: {
    value: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      date: new Date().toISOString().substr(0, 7),
      selectedDate: new Date().getMonth() + 1,
      showDate: this.value,
      menu: false,
      monthList: [
        "",
        "JANUARY",
        "FEBUARY",
        "MARCH",
        "APRIL",
        "MAY",
        "JUNE",
        "JULY",
        "AUGUST",
        "SEPTEMBER",
        "OCTOBER",
        "NOVEMBER",
        "DECEMBER"
      ]
    }
  },
  watch: {
    value(val) {
      const year = val.split(" ")[0];
      const monthText = val.split(" ")[1];
      const month = this.monthList.findIndex(x => x === monthText);
      this.date = `${year}-${month}`;
      this.showDate = val;
    },
    // menu(val) {
    //   val && setTimeout(() => (this.$refs.picker.activePicker = "YEAR"));
    // }
  },
  methods: {
    onChange(date) {
      this.date = date;
      // remove 0 for month 1-9 like: 2020-7
      if (date.split('-')[1][0] === '0') {
        this.showDate = date.split('-')[0] + ' ' + this.monthList[date.split('-')[1][1]];
      } else {
        this.showDate = date.split('-')[0] + ' ' + this.monthList[date.split('-')[1]];
      }
      this.$emit("onPress", date);
    },
    localeChange(val) {
      if (this.lang === 'th') {
        let x = val.split(' ');
        let year = parseInt(x[0]) + 543;
        let month = moment().month(x[1]).locale('th').format('MMMM');
        return year + ' ' + month;
      } else {
        return val;
      }
    }
  },
  computed: {
    ...mapState({
      lang: state => state.Branch.lang
    })
  }
};
</script>

<style>
</style>
